import type { AppliedFilterChipData } from "./types";

export const SEARCH_FILTERS_PANEL_ID = "SearchFiltersPanel";
export const EMPTY_APPLIED_FILTER_CHIPS: AppliedFilterChipData[] = [];
